export default "__VITE_ASSET__a0641caa__"